import { getGlossary, findGlossaryItemByTrigger, DATA_GLOSSARY_TRIGGER_ATTR, highlightGlossaryItems, } from '@as-react/common-utils';
import { useEffect, useRef, useState } from 'react';
import { useGlossary } from './useGlossary';
/**
 * Hook for managing glossary tooltips within popovers.
 * Finds already-highlighted elements and returns data for rendering Tooltip or Popover components.
 *
 * @param container - Ref to the popover container
 * @param isInsidePopover - Whether the container is inside a popover
 * @returns Object with highlighted elements for tooltip rendering
 */
export const useGlossaryHighlightInPopover = (container, isInsidePopover) => {
    const { isSuccess } = useGlossary();
    const isProcessed = useRef(false);
    const [highlightedElements, setHighlightedElements] = useState([]);
    useEffect(() => {
        const processHighlightedItems = () => {
            if (!container || !container.current) {
                return;
            }
            const glossary = getGlossary();
            if (!glossary) {
                return;
            }
            highlightGlossaryItems(glossary, container.current);
            const highlightedItems = container.current.querySelectorAll(`a[${DATA_GLOSSARY_TRIGGER_ATTR}]`);
            const elements = [];
            highlightedItems.forEach(item => {
                var _a;
                const trigger = (_a = item.textContent) === null || _a === void 0 ? void 0 : _a.toLowerCase().trim();
                if (trigger) {
                    const glossaryItem = findGlossaryItemByTrigger(trigger, glossary);
                    if (glossaryItem) {
                        elements.push({
                            element: item,
                            glossaryItem,
                        });
                    }
                }
            });
            setHighlightedElements(elements);
            isProcessed.current = true;
        };
        if ((container === null || container === void 0 ? void 0 : container.current) && !isProcessed.current && isSuccess) {
            processHighlightedItems();
        }
    }, [isInsidePopover, container, isSuccess]);
    return { highlightedElements };
};
